import { BigNumber } from 'ethers';
import { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectBridgeSlice } from '../redux/slices/bridgeSlice';
import {
  getWalletBalance,
  selectWalletSlice,
} from '../redux/slices/walletSlice';

const useFromChainBalance = (): BigNumber | undefined => {
  const [balance, setBalance] = useState<BigNumber>();
  const { selectedFromChain, fromChainToken } = useSelector(selectBridgeSlice);
  const { connectedWallets, fromChainWalletProvider } =
    useSelector(selectWalletSlice);

  const chainToken = useMemo(
    () =>
      selectedFromChain?.chainTokenList.find(
        (token) => token.symbol === fromChainToken?.symbol,
      ),
    [selectedFromChain?.chainTokenList, fromChainToken?.symbol],
  );

  useEffect(() => {
    if (!chainToken || !fromChainWalletProvider) {
      setBalance(undefined);
      return;
    }
    const fromChainWalletAddress =
      connectedWallets[fromChainWalletProvider.symbol];
    if (!fromChainWalletAddress) {
      return;
    }

    // getWalletBalance의 여러번 호출의 경우 이전 결과값을 무효화 하기 위한 Flag값
    let isExpired = false;
    if (
      fromChainWalletProvider.symbol === `METAMASK` &&
      chainToken.chainSymbol === `ETH`
    ) {
      getWalletBalance(
        chainToken,
        fromChainWalletProvider,
        fromChainWalletAddress,
      ).then((_balance) => {
        if (!isExpired) {
          setBalance(_balance);
        }
      });
    }

    if (
      fromChainWalletProvider.symbol === `KSTADIUM` &&
      chainToken.chainSymbol === `KS_BESU`
    ) {
      // TODO: kstadium 지갑의 balance가져오기
      getWalletBalance(
        chainToken,
        fromChainWalletProvider,
        fromChainWalletAddress,
      ).then((_balance) => {
        if (!isExpired) {
          setBalance(_balance);
        }
      });
    }

    // eslint-disable-next-line consistent-return
    return () => {
      isExpired = true;
    };
  }, [chainToken, connectedWallets, fromChainWalletProvider]);
  return balance;
};

export default useFromChainBalance;
